var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-calculation"},[_c('div',{staticClass:"calculation-body"},[_c('div',{staticClass:"calculation-title"}),_c('div',{staticClass:"calculation-text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('div',{staticClass:"calculation-progress",style:({'animation-duration':_vm.total + 'ms'})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }